var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelevision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 744.09447 1052.362179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 587.28,
    x2: 713.51,
    y1: 205.47,
    y2: 341.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 104.44,
    x2: 449.6,
    y1: 312.96,
    y2: 586.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9d4ef",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9d4ef",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 333.39,
    x2: 351.52,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 295.79,
    x2: 313.92,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 401.6,
    x2: 419.73,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 379.64,
    x2: 381.61,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 364.16,
    x2: 380.78,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 441.57,
    x2: 443.54,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 317.32,
    x2: 434.82,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 788,
    x2: 828,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 46.603,
    x2: 242.56,
    y1: 265.84,
    y2: 441.08,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 20.33,
    x2: 720.78,
    y1: 264.05,
    y2: 756.75,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 377.84,
    x2: 402.73,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3176 .38521 .38521 1.3176 -187.76 -173.59)",
    d: "m-347.11 794.05a12.143 7.9609 0 0 1 12.143 7.9609v69.763a12.143 7.9609 0 0 1 -12.143 7.9609 12.143 7.9609 0 0 1 -12.143 -7.9609v-69.763a12.143 7.9609 0 0 1 12.143 -7.9609",
    fill: "#b57c00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3405 -.29594 .38903 1.3165 -187.76 -173.59)",
    d: "m342.45 778.06c5.0218 0 9.0646 3.5436 9.0646 7.9453v55.456c0 4.4017-4.0428 7.9453-9.0646 7.9453s-9.0647-3.5436-9.0647-7.9453v-55.456c0-4.4017 4.0428-7.9453 9.0647-7.9453z",
    fill: "url(#n)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3176 .38521 .38521 1.3176 -193.25 -185.95)",
    d: "m-309.61 794.02a12.143 7.9609 0 0 1 12.143 7.9609v69.763a12.143 7.9609 0 0 1 -12.143 7.9609 12.143 7.9609 0 0 1 -12.143 -7.9609v-69.763a12.143 7.9609 0 0 1 12.143 -7.9609",
    fill: "#cc7c04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3405 -.29594 .38903 1.3165 -193.25 -185.95)",
    d: "m304.86 780.56c5.0218 0 9.0646 3.5436 9.0646 7.9453v55.456c0 4.4017-4.0428 7.9453-9.0646 7.9453s-9.0647-3.5436-9.0647-7.9453v-55.456c0-4.4017 4.0428-7.9453 9.0647-7.9453z",
    fill: "url(#m)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(16.297)",
    d: "m395.74 657.76c9.2349 0 16.67 4.8741 16.67 10.929v95.768c0 6.0544-7.4346 10.929-16.67 10.929s-16.67-4.8742-16.67-10.929v-95.768c0-6.0544 7.4346-10.929 16.67-10.929z",
    fill: "#b57c00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93878,.34451,-.27796,.96059,0,0)",
    d: "m390.28 645.78c6.8938 0 12.444 4.8646 12.444 10.907v76.128c0 6.0425-5.5499 10.907-12.444 10.907s-12.444-4.8646-12.444-10.907v-76.128c0-6.0426 5.5499-10.907 12.444-10.907z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3176 .38521 -.38521 1.3176 -187.76 -173.59)",
    d: "m414.59 573.44a12.143 7.9609 0 0 1 12.143 7.9609v69.763a12.143 7.9609 0 0 1 -12.143 7.9609 12.143 7.9609 0 0 1 -12.143 -7.9609v-69.763a12.143 7.9609 0 0 1 12.143 -7.9609",
    fill: "#cc7c04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.2887 .47293 -.38158 1.3187 -187.76 -173.59)",
    d: "m410.66 556.22c5.0218 0 9.0646 3.5436 9.0646 7.9453v55.456c0 4.4017-4.0428 7.9453-9.0646 7.9453s-9.0647-3.5436-9.0647-7.9453v-55.456c0-4.4017 4.0428-7.9453 9.0647-7.9453z",
    fill: "url(#l)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3498 -.2504 .2504 1.3498 -229.26 -58.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.79 150.93a2.5 7.2845 0 0 1 2.5 7.2845v91.145a2.5 7.2845 0 0 1 -2.5 7.2845 2.5 7.2845 0 0 1 -2.5 -7.2845v-91.145a2.5 7.2845 0 0 1 2.5 -7.2845",
    fill: "#000004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.63 154.86c0.5441 0 0.98214 3.2489 0.98214 7.2845v84.334c0 4.0356-0.43804 7.2845-0.98214 7.2845s-0.98215-3.2489-0.98215-7.2845v-84.334c0-4.0356 0.43804-7.2845 0.98215-7.2845z",
    fill: "url(#k)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.67178 0 0 .67178 73.994 -59.175)",
    d: "m380.78 163.53a8.3085 7.0711 0 1 1 -16.617 0 8.3085 7.0711 0 1 1 16.617 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.53225 0 0 .53225 124.79 -36.243)",
    d: "m380.78 163.53c0 3.9032-3.7222 7.0711-8.3085 7.0711s-8.3085-3.1678-8.3085-7.0711 3.7222-7.0711 8.3085-7.0711 8.3085 3.1678 8.3085 7.0711z",
    fill: "url(#c)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3728 0 0 1.3728 -176.09 -178.06)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.98322,-.18241,-.18241,.98322,0,0)",
    d: "m-443.14 86.681a2.5 7.2845 0 0 1 2.5 7.2845v91.145a2.5 7.2845 0 0 1 -2.5 7.2845 2.5 7.2845 0 0 1 -2.5 -7.2845v-91.145a2.5 7.2845 0 0 1 2.5 -7.2845",
    fill: "#000004"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(10.679)",
    d: "m442.56 88.689c0.5441 0 0.98214 3.2489 0.98214 7.2845v84.334c0 4.0356-0.43804 7.2845-0.98214 7.2845s-0.98215-3.2489-0.98215-7.2845v-84.334c0-4.0356 0.43804-7.2845 0.98215-7.2845z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.48936 0 0 .48936 237.37 86.55)",
    d: "m380.78 163.53a8.3085 7.0711 0 1 1 -16.617 0 8.3085 7.0711 0 1 1 16.617 0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.38771 0 0 .38771 274.37 103.25)",
    d: "m380.78 163.53c0 3.9032-3.7222 7.0711-8.3085 7.0711s-8.3085-3.1678-8.3085-7.0711 3.7222-7.0711 8.3085-7.0711 8.3085 3.1678 8.3085 7.0711z",
    fill: "url(#c)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m92.101 200.3h562.03c47.486 0 85.714 27.397 85.714 61.429v435.45c0 34.031-38.229 61.429-85.714 61.429h-562.03c-47.486 0-85.714-27.397-85.714-61.429v-435.45c0-34.031 38.229-61.429 85.714-61.429z",
    fill: "#cc7c04"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m88.571 198.45h562.03c47.486 0 85.714 27.397 85.714 61.429v435.45c0 34.031-38.229 61.429-85.714 61.429h-562.03c-47.486 0-85.714-27.397-85.714-61.429v-435.45c0-34.031 38.229-61.429 85.714-61.429z",
    fill: "url(#e)",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m125.44 235.6h397.29c47.486 0 85.714 27.397 85.714 61.429v347.81c0 34.031-38.229 61.429-85.714 61.429h-397.29c-47.486 0-85.714-27.397-85.714-61.429v-347.81c0-34.031 38.229-61.429 85.714-61.429z",
    fill: "#83b5d9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m158.78 274.82h205.1c47.486 0 85.714 27.397 85.714 61.429v188.76c0 34.031-38.229 61.429-85.714 61.429h-205.1c-47.486 0-85.714-27.397-85.714-61.429v-188.76c0-34.031 38.229-61.429 85.714-61.429z",
    fill: "url(#f)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3728 0 0 1.3728 -187.76 -173.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.34 258.79h157.9a6.7642 7.1429 0 0 1 6.7642 7.1429 6.7642 7.1429 0 0 1 -6.7642 7.1429h-157.9a6.7642 7.1429 0 0 1 -6.7642 -7.1429 6.7642 7.1429 0 0 1 6.7642 -7.1429",
    fill: "#000004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.09 259.68h103.97a6.7642 4.1071 0 0 1 6.7642 4.1071 6.7642 4.1071 0 0 1 -6.7642 4.1071h-103.97a6.7642 4.1071 0 0 1 -6.7642 -4.1071 6.7642 4.1071 0 0 1 6.7642 -4.1071",
    fill: "url(#i)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m166.55 341.34h41.357c19.198 0 34.654 12.361 34.654 27.714v44.304c0 15.354-15.456 27.714-34.654 27.714h-41.357c-19.198 0-34.654-12.361-34.654-27.714v-44.304c0-15.354 15.456-27.714 34.654-27.714z",
    fill: "url(#g)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98493 -.17297 -.0092481 .99996 0 0)",
    d: "m700.06 414.88h29.136c10.379 0 18.734 6.7892 18.734 15.222v179.39c0 8.4332-8.3554 15.222-18.734 15.222h-29.136c-10.379 0-18.734-6.7892-18.734-15.222v-179.39c0-8.4332 8.3555-15.222 18.734-15.222z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m91.512 200.64h474.33c47.486 0 85.714 27.397 85.714 61.429v435.45c0 34.031-38.229 61.429-85.714 61.429h-474.33c-47.486 0-85.714-27.397-85.714-61.429v-435.45c0-34.031 38.229-61.429 85.714-61.429z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2881
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0651 0 0 1.0651 -253.2 135.55)",
    d: "m828 541.36a20 19 0 1 1 -40 0 20 19 0 1 1 40 0z",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0651 0 0 1.0651 -253.62 135.61)",
    d: "m828 541.36c0 10.488-8.96 19-20 19s-20-8.512-20-19 8.96-19 20-19 20 8.512 20 19z",
    fill: "url(#b)",
    opacity: 0.75519
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.56 184.61)",
    d: "m828 541.36a20 19 0 1 1 -40 0 20 19 0 1 1 40 0z",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.268 184.65)",
    d: "m828 541.36c0 10.488-8.96 19-20 19s-20-8.512-20-19 8.96-19 20-19 20 8.512 20 19z",
    fill: "url(#b)",
    opacity: 0.75519
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.56 220.3)",
    d: "m828 541.36a20 19 0 1 1 -40 0 20 19 0 1 1 40 0z",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.268 220.34)",
    d: "m828 541.36c0 10.488-8.96 19-20 19s-20-8.512-20-19 8.96-19 20-19 20 8.512 20 19z",
    fill: "url(#b)",
    opacity: 0.75519
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.56 148.91)",
    d: "m828 541.36a20 19 0 1 1 -40 0 20 19 0 1 1 40 0z",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73428 0 0 .73428 33.268 148.95)",
    d: "m828 541.36c0 10.488-8.96 19-20 19s-20-8.512-20-19 8.96-19 20-19 20 8.512 20 19z",
    fill: "url(#b)",
    opacity: 0.75519
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m580 202.12 89.393-0.94975s64.151 10.982 69.556 55.071c0.56497 38.743-0.12132 106.26-0.12132 106.26l-85.757-0.14214s-0.59189-75.95-3.6569-118.49c-29.935-44.657-69.414-41.757-69.414-41.757z",
    fill: "url(#h)",
    fillRule: "evenodd",
    opacity: 0.48548
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/television.b610e8f4378bb0e3d2a884be649e1a35.svg";
export { ForwardRef as ReactComponent };